import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { L } from 'harmony-language';
import React from 'react';
import { getTransLocationType } from '../../../../../constants/constants';
import { LocationType } from '../../../../../types';
import { SiteProjection } from '../bulk-drafts-types';

interface BulkEntryTitleBarProps {
    siteType: LocationType;
    siteProjections: SiteProjection[];
    previewLoads: () => void;
    handleBack: () => void;
}

const getTotalLoads = (siteProjections: SiteProjection[]) => {
    return siteProjections.reduce((totalAcrossSites, siteProjection) => {
        return totalAcrossSites + siteProjection.projectionWeek.reduce((weekTotal, week) => {
            return weekTotal + week.schedule.reduce((dayTotal, load) => {
                return dayTotal + load;
            }, 0);
        }, 0);
    }, 0);
};

const getSitesWithLoads = (siteProjections: SiteProjection[]) => {
    return siteProjections.reduce((sitesWithLoads, siteProjection) => {
        return sitesWithLoads + (siteProjection.projectionWeek.some(week =>
            week.schedule.some(load => load > 0)
        ) ? 1 : 0);
    }, 0);
};

export const BulkEntryTitleBar = (props: BulkEntryTitleBarProps) => {
    const { siteType, siteProjections, previewLoads, handleBack } = props;

    return (
        <div className='bulk-title-bar justify-between'>
            <Button variant='outlined' color='primary' startIcon={<ArrowBackIcon />} onClick={handleBack}>
                {L.goBack()}
            </Button>
            {getTotalLoads(siteProjections) > 0 &&
                <h4>{L.bulkEntryPreview(getTotalLoads(siteProjections).toString(), getSitesWithLoads(siteProjections).toString(), getTransLocationType(siteType).label)}</h4>
            }
            <Button variant='contained' color='primary' onClick={previewLoads} disabled={getTotalLoads(siteProjections) <= 0}>
                {L.previewDrafts()}
            </Button>
        </div>
    );
};
